// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.codes-module__modal___Hr6aP {
  background-color: var(--base, #f4f4f7);
  overflow-y: scroll;
  max-height: 70vh;
}

.codes-module__loading___yvgl8 {
  height: 70px;
}

.codes-module__not-found___ISVd7 {
  height: 50px;
  line-height: 50px;
  text-align: center;
  width: 100%;
}`, "",{"version":3,"sources":["data:;charset=utf-8,/**%20function%20to%20get%20dimensions%0A%20%20usage%20example%20to%20get%20%60tablet%60%20value%20from%20%60$page-max-widths%60%0A%20%20.class%20%7B%0A%20%20%20%20max-width:%20dim($page-max-widths,%20tablet);%0A%20%20%7D%0A%0A%20*/%0A%0A@use%20'sass:map';%0A%0A@function%20dim($prop,%20$key)%20%7B%0A%20%20@return%20map.get($prop,%20$key);%0A%7D%0A","webpack://./client/app/pages/spot-rewards/view/components/codes/codes.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,sCAAA;EACA,kBAAA;EACA,gBAAA;AAMF;;AAHA;EACE,YAAA;AAMF;;AAHA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AAMF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `codes-module__modal___Hr6aP`,
	"loading": `codes-module__loading___yvgl8`,
	"not-found": `codes-module__not-found___ISVd7`
};
export default ___CSS_LOADER_EXPORT___;
